import styled from "@emotion/styled";
import React, { useMemo } from "react";
import Scroll from "react-scroll";
import useWindowSize from "react-use/lib/useWindowSize";
import { Button } from "../Button";
import { getNumberOfTilesPerPage } from "../OmniForest/utils/get-number-of-tiles-per-page";

const OuterWrapper = styled.div`
  margin: 48px 0 0;
`;

type Props = {
  canGetMore: boolean;
  onClick: () => void;
  totalTiles: number;
};

export const ShowOlderButton: React.FC<Props> = ({
  canGetMore,
  onClick,
  totalTiles,
}) => {
  const { width: windowWidth } = useWindowSize();
  const forestTilesPerPage = getNumberOfTilesPerPage(windowWidth);

  const scrollToTopDelay = useMemo(
    () => (totalTiles / forestTilesPerPage) * 250,
    [totalTiles]
  );

  return (
    <OuterWrapper>
      {canGetMore ? (
        <Button spruce text="Load more" onClick={(e) => onClick()} />
      ) : (
        <Button
          text={`Go back to the top`}
          spruce
          onClick={(e) => {
            Scroll.scroller.scrollTo("forest", {
              duration: scrollToTopDelay,
              offset: -50,
              smooth: true,
            });
          }}
        />
      )}
    </OuterWrapper>
  );
};
